import {
  getListHistory, getListCreditPurchaseHistory, getTotalHistory, getListSubscriptionHistory,
  getTotalSubscriptionHistory, getListRedemptionHistory, getGrossSubscriptionHistory,
} from '@/services/transaction-admin';

const getters = {
  list_history: state => state.list_history,
  list_credit_purchase_history: state => state.list_credit_purchase_history,
  total_history: state => state.total_history,
  total_subscription_history: state => state.total_subscription_history,
  gross_subscription_history: state => state.gross_subscription_history,
  list_subscription_history: state => state.list_subscription_history,
  list_redemption_history: state => state.list_redemption_history,
  per_page: state => state.per_page,
};

const actions = {
  async requestListHistory({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_HISTORY', response);
      dispatch('requestTotalHistory', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListCreditPurchaseHistory({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListCreditPurchaseHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_CREDIT_PURCHASE_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestTotalHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getTotalHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_TOTAL_HISTORY', response.data ? response.data.total_amount : 0);
    } catch (err) {
      commit('SET_TOTAL_HISTORY', 0);
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListSubscriptionHistory({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListSubscriptionHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_SUBSCRIPTION_HISTORY', response);
      dispatch('requestTotalSubscriptionHistory', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestTotalSubscriptionHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const responseTotal = await getTotalSubscriptionHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      const responseGross = await getGrossSubscriptionHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      const total_subscription_history = responseTotal.data ? responseTotal.data.total_price : 0;
      const gross_subscription_history = responseGross.data ? responseGross.data.total_price : 0;
      commit('SET_STATISTIC_SUBSCRIPTION_HISTORY', { total_subscription_history, gross_subscription_history });
    } catch (err) {
      commit('SET_STATISTIC_SUBSCRIPTION_HISTORY', { total_subscription_history: 0, gross_subscription_history: 0 });
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListRedemptionHistory({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListRedemptionHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_REDEMPTION_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_HISTORY(state, list_history) {
    state.list_history = list_history;
  },
  SET_LIST_CREDIT_PURCHASE_HISTORY(state, list_credit_purchase_history) {
    state.list_credit_purchase_history = list_credit_purchase_history;
  },
  SET_TOTAL_HISTORY(state, total_history) {
    state.total_history = total_history;
  },
  SET_STATISTIC_SUBSCRIPTION_HISTORY(state, { total_subscription_history, gross_subscription_history }) {
    state.total_subscription_history = total_subscription_history;
    state.gross_subscription_history = gross_subscription_history;
  },
  SET_LIST_SUBSCRIPTION_HISTORY(state, list_subscription_history) {
    state.list_subscription_history = list_subscription_history;
  },
  SET_LIST_REDEMPTION_HISTORY(state, list_redemption_history) {
    state.list_redemption_history = list_redemption_history;
  },
};

export default {
  namespaced: true,
  state: {
    list_history: [],
    list_credit_purchase_history: [],
    list_subscription_history: [],
    list_redemption_history: [],
    total_history: 0,
    gross_subscription_history: 0,
    total_subscription_history: 0,
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/TransactionAdmin/index.js